import React, { useEffect } from 'react';
import { ReactComponent as LeftArrow } from 'icons/left-arrow.svg';
import { ReactComponent as BellIcon } from 'icons/bell-filled-icon.svg';
import { createSearchParams, useNavigate } from 'react-router-dom';
import { Button, TableWrapper } from 'components/Global';
import { useDispatch, useSelector } from 'react-redux';
import { format, parseISO } from 'date-fns';
import { id } from 'date-fns/locale';
import { fetchOrderById } from 'features/orders/actions';
import { setCurrency } from 'utils/functionality';
import { useFliptBoolean } from '@flipt-io/flipt-client-react';

const ChatType = {
  'message from order detail': 'cs-order',
  'message from customer': 'cs-customer',
  'message from driver': 'cs-driver',
};

const NotificationDetail = ({ setShowDetail, getNotificationIcon, getAllInboxes }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const inbox = useSelector((state) => state.notificationInbox.selected);
  const { data: orderData } = useSelector((state) => state.detailOrder);
  const user = useSelector((state) => state.user.profile);

  const isCarCharterEnabled = useFliptBoolean('FLAG_CHARTER', false, user.id || 'anonymous');

  const getDriverType = (isWithoutDriver) => (isWithoutDriver ? 'without-driver' : 'with-driver');

  const getOrderType = (orderTypeId, isWithoutDriver) => {
    if (orderTypeId === 1) return getDriverType(isWithoutDriver);
    else if (orderTypeId === 2 || orderTypeId === 7) return 'airport-transfer';
    else if (isCarCharterEnabled && orderTypeId === 8) return 'car-charter';
  };

  const getCustomerId = () => {
    if (inbox.custom_data?.customer_id) {
      return inbox.custom_data.customer_id;
    } else if (inbox.custom_data?.user_id) {
      return inbox.custom_data.user_id;
    } else {
      return orderData?.customer_id;
    }
  };

  const inboxMessageView = (title, message) => {
    if (
      title === 'Berhasil Membatalkan Tugas' ||
      title === 'Orderan Berhasil Diambil Driver' ||
      title === 'Notifikasi Belum ada Driver'
    ) {
      return <p dangerouslySetInnerHTML={{ __html: message }} />;
    } else {
      return message;
    }
  };

  const handleClick = (title) => {
    if (inbox.custom_data?.key === 'admin_withdraw_request') {
      navigate(`/driver/withdraw?id=${inbox.custom_data.withdraw_id}`);
      return;
    }

    if (
      orderData.order_type_id === 7 &&
      (title === 'pengajuan pembatalan tugas' ||
        title === 'berhasil  membatalkan tugas' ||
        title === 'orderan berhasil diambil driver' ||
        title === 'notifikasi belum ada driver (h-1 hari)' ||
        title === 'notifikasi belum ada driver (h-20 menit)' ||
        title === 'notifikasi belum ada driver (h-15 menit)' ||
        title === 'notifikasi belum ada driver')
    ) {
      navigate({
        pathname: `/driver/driver-task`,
        search: createSearchParams({
          key: inbox.custom_data?.order_id,
          customer_Id: getCustomerId(),
          id: inbox.custom_data.task_id,
        }).toString(),
      });
      return;
    }

    if (title === 'customer updated bank data') {
      navigate(`/refund-dana/${inbox.custom_data.refund_order_id}`);
      return;
    }

    if (title === 'aktivitas mencurigakan') {
      navigate(`/user-customer/detail/${inbox.custom_data.user_id}`);
      return;
    }

    const orderType = getOrderType(orderData?.order_type_id, orderData?.order_detail?.without_driver);
    navigate({
      pathname: `/${orderType}/detail/${orderData.transaction_key}`,
      search: createSearchParams({
        customerId: getCustomerId(),
      }).toString(),
    });
  };

  const handleShowMessage = () => {
    navigate({
      pathname: '/messages',
      search: createSearchParams({
        chatType: ChatType[inbox.title.toLowerCase()],
      }).toString(),
    });
  };

  const handleShowReview = (id) => {
    navigate(`/review/${id}`);
  };

  const handleShowDriver = (id) => {
    navigate(`/driver/verification/${id}`);
  };

  const handleBack = () => {
    setShowDetail(false);
    dispatch(getAllInboxes);
  };

  const gotFeeCurrency = (fee, currency) => {
    let RightFee = '';

    if (fee && currency === 'IDR') {
      RightFee = setCurrency(fee).replace('Rp', `${currency}`);
    } else if (fee && currency === 'SGD') {
      RightFee = `${currency} ${fee.toFixed(2)}`;
    } else if (fee === 0) {
      RightFee = `${currency} 0`;
    } else {
      RightFee = '-';
    }

    return RightFee;
  };

  useEffect(() => {
    if (!Object.hasOwn(inbox, 'custom_data')) return;
    if (inbox.custom_data.order_id) {
      dispatch(fetchOrderById(inbox.custom_data.order_id));
    }
  }, [inbox]);

  const showButtonDetailMessage =
    inbox?.title?.toLowerCase() === 'message from order detail' ||
    inbox?.title?.toLowerCase() === 'message from customer' ||
    inbox?.title?.toLowerCase() === 'message from driver';

  const showButtonLihatReview = inbox?.title?.toLowerCase() === 'review baru';
  const showButtonDownloadInvoice = inbox?.title?.toLowerCase() === 'pesanan dikonfirmasi';
  const showButtonDataDriver = inbox?.title?.toLowerCase() === 'pengajuan verifikasi driver baru';
  const showButtonLihatOrder =
    !showButtonDetailMessage && !showButtonLihatReview && !showButtonDownloadInvoice && !showButtonDataDriver;

  return (
    <div className="notification-detail">
      <div className="notification-detail__back-btn" onClick={handleBack}>
        <LeftArrow />
        <p>Kembali</p>
      </div>

      <div className="notification-detail__body">
        <TableWrapper title="Notifikasi" icon={<BellIcon fill="#009EF7" width="25px" height="25px" />}>
          <div className="notification-detail__item">
            <div className="notification-detail__item--header">
              {getNotificationIcon(inbox.title?.toLowerCase())}
              <div className="notification-detail__item--body">
                <h1 className="notification-detail__item--body-title">{inbox.title}</h1>
                <p className="notification-detail__item--body-created-at">
                  {inbox.created_at &&
                    format(parseISO(inbox.created_at), 'dd LLLL yyyy, HH:mm', {
                      locale: id,
                    })}
                </p>
                <p className="notification-detail__item--body-message">
                  {inbox.custom_data?.key === 'admin_withdraw_request' ? (
                    <div className="withdraw-notification">
                      <p>💰 Permintaan Penarikan Dana</p>
                      <p>
                        Driver {inbox?.custom_data?.driver_name} telah mengajukan permintaan penarikan dana dengan
                        detail sebagai berikut :
                      </p>
                      <div>
                        <span />
                        <p>
                          Jumlah Penarikan: {gotFeeCurrency(inbox?.custom_data?.amount, inbox?.custom_data?.currency)}
                        </p>
                      </div>
                      <div>
                        <span />
                        <p>
                          Tanggal Pengajuan:{' '}
                          {format(parseISO(inbox?.custom_data?.date_request), 'dd MMMM yyyy', { locale: id })}
                        </p>
                      </div>
                      <p>
                        Silakan tinjau dan proses permintaan ini melalui sistem admin. Pastikan semua data sudah sesuai
                        sebelum melakukan konfirmasi. ✅
                      </p>
                      <p className="footer-note">
                        Catatan: Admin sebaiknya memeriksa riwayat transaksi driver sebelum menyetujui permintaan ini
                      </p>
                    </div>
                  ) : (
                    inboxMessageView(inbox.title, inbox.message)
                  )}
                </p>
              </div>
            </div>

            {showButtonDetailMessage ? (
              <div className="notification-detail__item--button">
                <Button onClick={handleShowMessage} width="135px" height="39px" className="button-order">
                  Lihat Pesan
                </Button>
              </div>
            ) : null}

            {showButtonLihatOrder ? (
              <div className="notification-detail__item--button">
                <Button
                  onClick={() => handleClick(inbox.title?.toLowerCase())}
                  width="135px"
                  height="39px"
                  className="button-order"
                >
                  Lihat Order
                </Button>
              </div>
            ) : null}

            {showButtonLihatReview ? (
              <div className="notification-detail__item--button">
                <Button
                  onClick={() => handleShowReview(inbox?.custom_data?.review_id)}
                  width="135px"
                  height="39px"
                  className="button-order"
                >
                  Lihat Review
                </Button>
              </div>
            ) : null}

            {showButtonDownloadInvoice ? (
              <div className="notification-detail__item--button">
                <Button width="135px" height="39px" className="button-order">
                  <a
                    download="invoice.pdf"
                    target="_blank"
                    href={inbox?.custom_data?.invoice}
                    rel="noreferrer"
                    style={{ color: 'white' }}
                  >
                    Download Invoice
                  </a>
                </Button>
              </div>
            ) : null}

            {showButtonDataDriver ? (
              <div className="notification-detail__item--button">
                <Button
                  width="135px"
                  height="39px"
                  className="button-order"
                  onClick={() => handleShowDriver(inbox?.custom_data?.user_id)}
                >
                  Lihat Data Driver
                </Button>
              </div>
            ) : null}
          </div>
        </TableWrapper>
      </div>
    </div>
  );
};

export default NotificationDetail;
